<template>
    <div class="cabinet">
        <asideCabinet />
        <div class="cabinet-content">
            <headerCabinet />
            <router-view />
        </div>
    </div>
</template>

<script>
    import asideCabinet from "@/views/cabinet/asideCabinet.vue";
    import headerCabinet from "@/views/cabinet/headerCabinet.vue";
    export default {
        name: 'cabinet',
        components: {
            asideCabinet,
            headerCabinet
        },
        data () {
            return {

            }
        }
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/cabinet/cabinet.vue